import { getSubdomain } from './authStorage';

export function getSubdomainFromUrl() {
  const host = window.location.hostname;
  const baseDomain = process.env.REACT_APP_BASE_DOMAIN || 'localhost';
  // host = "company1.lvh.me" or "company1.localhost"

  const parts = host.split('.');

  // localhost only — no subdomain
  if (host === 'localhost') return null;

  // *.localhost → ["company1", "localhost"]
  if (host.endsWith('.localhost')) {
    return parts[0];
  }

  // *.lvh.me → ["company1", "lvh", "me"]
  if (host.endsWith('.lvh.me')) {
    return parts[0];
  }

  // For dev and prod — dynamically check against base domain from env
  if (baseDomain !== 'localhost' && host.endsWith(`.${baseDomain}`)) {
    return parts[0]; // always first part = tenant subdomain
  }

  return null;
}

/** Subdomain for auth API bodies — URL first, then value saved at sign-in. */
export function getRequestSubdomain() {
  return getSubdomainFromUrl() || getSubdomain() || null;
}
